import React from 'react';
import propTypes from 'prop-types';
export const EditIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 860.632 860.632"
      enableBackground="new 0 0 860.632 860.632"
      xmlSpace="preserve"
      stroke={color}
    >
      <g>
        <g>
          <path
            d="M515.582,157.916l-439.199,439.2l4.6,10.1l27.1,58.8l41.6,22c9.8,5.2,17.7,13.101,22.9,22.9l22,41.6l58.8,27.101
       l10.101,4.6l439.2-439.2L515.582,157.916z"
          />
          <path
            d="M853.282,159.216l-151.8-151.8c-4.9-4.9-11.3-7.3-17.7-7.3s-12.8,2.4-17.7,7.3l-129.3,129.3l187.2,187.2l129.3-129.3
       C863.082,184.816,863.082,169.016,853.282,159.216z"
          />
          <path
            d="M46.083,650.016l-4.3,16.9l-41,162.5c-4.1,16.2,8.5,31.1,24.1,31.1c2,0,4.1-0.3,6.2-0.8l162.5-41l16.9-4.3l16.9-4.3
       l13.3-3.4l-30.9-14.2l-29.5-13.5c-5-2.3-9.1-6.199-11.7-11l-18.6-35.1l-4.3-8c-2.3-4.4-6-8.1-10.4-10.4l-8-4.3l-35.1-18.6
       c-4.9-2.601-8.7-6.7-11-11.7l-13.5-29.5l-14.2-30.9l-3.4,13.301L46.083,650.016z"
          />
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
EditIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
EditIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
